import * as yup from 'yup';

export const commonQuotationSettingValidation: { [x: string]: any; } = {
    consortiumCode: yup.string().required("Missing."),
    vesselCode: yup.string().required("Missing."),
    voyageCode: yup.string().required("Missing."),
    etd: yup.date().required("Missing."),
    quotationNo: yup.string().required("Missing."),
    quotationDesc: yup.string().required("Missing."),
    quotationAmount: yup.number().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createQuotationSettingValidation: { [x: string]: any; } = {
    ...commonQuotationSettingValidation,
};

export const createQuotationSettingValidationSchema = yup.object().shape(createQuotationSettingValidation);

